import { useParams } from 'react-router-dom';
import React, { useState, useEffect,useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { ROUTES, USER_ROLES, USERS_ROLE } from "../../../utilities/constant";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { API_INCOMING_SUMMARY_LIST, DOWNLOAD_REPORT, API_INCOMING_REPORT_BY_DID_LIST } from '../../../service/url';
import { getApiCall } from '../../../service/getApiCall';
import { formatDateTime } from '../../../utilities/helpers';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { PhoneIncoming, PhoneOutgoing } from "lucide-react";
import '../../../assets/custom/css/tabs.css'
import AsyncStorage from '@react-native-async-storage/async-storage';


const DidDetailPage = () => {

  const audioRefs = useRef({});
  const statusStyles = {
    success: {
      backgroundColor: "rgba(0, 128, 0, 0.1)",
      color: "#006400",
      width: "85px",
      padding: "4px 10px",
      borderRadius: "4px",
      textAlign: "center",
      margin: 0
    },
    failed: {
      backgroundColor: "rgba(255, 0, 0, 0.1)",
      color: "#b00000",
      width: "60px",
      padding: "4px 10px",
      borderRadius: "4px",
      textAlign: "center",
      margin: 0
    },
    failedAbsolute: {
      backgroundColor: "rgba(255, 0, 0, 0.1)",
      color: "#b00000",
      width: "60px",
      padding: "4px 10px",
      borderRadius: "4px",
      position: "absolute",
      top: "70px"
    },
    successAbsolute: {
      backgroundColor: "rgba(0, 128, 0, 0.1)",
      color: "#006400",
      width: "85px",
      padding: "4px 10px",
      borderRadius: "4px",
      position: "absolute",
      top: "70px"
    }
  };
  const { did, startDate, endDate } = useParams();
  const [incomingReport, setIncomingReport] = useState([]);
  const [detailStartDate, setDetailStartDate] = useState(startDate);
  const [detailEndDate, setDetailEndDate] = useState(endDate);

  const [playingId, setPlayingId] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [selectedCall, setSelectedCall] = useState([]);
  const [showSidePanel, setShowSidePanel] = useState(false);



  const [mainCall, setMainCall] = useState(null); // for clicked one
  const [relatedCalls, setRelatedCalls] = useState([]); // others with same trace_id


  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      const rawUser = await AsyncStorage.getItem('user');
      if (!rawUser) {
        console.error("User data not found in AsyncStorage");
        return;
      }
      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON in AsyncStorage user:", e);
        return;
      }
      setUserRole(user?.role);
    };
    fetchUserData()
  }, [])


  const fetchIncomingReport = (start, end) => {
    const formattedStart = moment(start).format("YYYY-MM-DD 00:00:00");
    const formattedEnd = moment(end).format("YYYY-MM-DD 23:59:59");

    getApiCall(`${API_INCOMING_REPORT_BY_DID_LIST}/${did}/${formattedStart}/${formattedEnd}`).then((data) => {
      setIncomingReport(data);
    })
      .catch(err => console.log(err));
  };



  useEffect(() => {
    fetchIncomingReport(detailStartDate, detailEndDate);
  }, [did, detailStartDate, detailEndDate]);

  const handleDetailFilter = () => {
    fetchIncomingReport(detailStartDate, detailEndDate);
  };

  const handleDetailClearFilter = () => {
    setDetailStartDate(startDate);
    setDetailEndDate(endDate);
    fetchIncomingReport(startDate, endDate);
  };

  const handlePlayPause = (id) => {
  const current = audioRefs.current[id];

  if (playingId && playingId !== id) {
    audioRefs.current[playingId]?.pause();
    audioRefs.current[playingId].currentTime = 0;
  }

  if (playingId === id) {
    current.pause();
    setPlayingId(null);
  } else {
    current.play();
    setPlayingId(id);
  }
};
  const actionBodyTemplate = (rowData) => {
    const hasRecording = !!rowData.recording_file;

    const handleViewClick = async () => {
      if (!rowData.trace_id) {
        console.warn("Trace ID is missing");
        return;
      }

      const start = encodeURIComponent(rowData.start_time);
      const end = encodeURIComponent(rowData.end_time);
      const did = encodeURIComponent(rowData.callee_number);
      const trace_id = encodeURIComponent(rowData.trace_id);

      try {
        const response = await getApiCall(
          `${API_INCOMING_REPORT_BY_DID_LIST}/${did}/${start}/${end}/${trace_id}`
        );

        const incoming = response?.incomingReports || [];
        const outbound = response?.outboundReports || [];

        let main;
        let rest;

        if (userRole === USER_ROLES.CALL_CENTRE_AGENT) {
          main = outbound.find(d => d.id === rowData.id);
          rest = incoming
        } else {
          main = incoming.find(d => d.id === rowData.id);
          rest = outbound;
        }

        setMainCall(main);
        setRelatedCalls(outbound);
        setShowSidePanel(true);
      } catch (err) {
        console.log(err);
      }
    };

    return (
      <>
        <button
          className="btn-icons m-1"
          onClick={handleViewClick}
          style={{ border: "none", background: "none", padding: "0" }}
        >
          <i
            className="fa fa-eye"
            aria-hidden="true"
            style={{ color: "blue", fontSize: "18px" }}
          ></i>
        </button>


        {hasRecording ? (
          <>
            <button
              className="btn-icons m-1"
              onClick={() => handlePlayPause(rowData.id)}
              style={{ border: "none", background: "none", padding: "0", position:'relative' }}
            >
              {playingId === rowData.id ? (
                // Pause icon
                <svg width="25" height="25" viewBox="0 0 24 24" style={{ color: 'blue',position:'absolute', bottom:"-5.5px", left:"-4px" }}>
                  <path
                    d="M6 5h4v14H6zM14 5h4v14h-4z"
                    fill="currentColor"
                  />
                </svg>
              ) : (
                <svg width="25" height="25" viewBox="0 0 24 24" style={{ color: 'blue',position:'absolute', bottom:"-5.5px", left:"-4px" }}>
                  <path
                    d="M8 5v14l11-7z"
                    fill="currentColor"
                  />
                </svg>
              )}
            </button>
            <audio
              ref={(el) => (audioRefs.current[rowData.id] = el)}
              src={rowData.recording_file}
            />
          </>
        ) : (
          null
        )}
      </>
    );
  };




  return (
    <div>
      <div className="card" style={{ marginTop: "20px" }} >
        <div className="card-header d-flex justify-content-between align-items-center">
          <button
            className="btn btn-primary"
            onClick={() => navigate(`/${ROUTES.IVR.INCOMING_SUMMARY}`)}
            style={{ marginRight: '10px' }}
          >
            {userRole === USER_ROLES.CALL_CENTRE_AGENT ? "Back to Outbound Summary" : "Back to Incoming Summary"}
          </button>
          <h4 className="card-title m-0">DID Detail View</h4>
        </div>
        <div className="card-body">
          <div className="d-flex align-items-center mb-3" style={{ marginLeft: "10px" }}>
            <Calendar
              value={detailStartDate}
              onChange={(e) => setDetailStartDate(e.value)}
              placeholder="Start Date"
              showIcon
            />
            <span className="mx-2">to</span>
            <Calendar
              value={detailEndDate}
              onChange={(e) => setDetailEndDate(e.value)}
              placeholder="End Date"
              showIcon
            />
            <Button
              label="Filter"
              onClick={handleDetailFilter}
              className="p-button-sm p-button-primary mx-2"
            />
            <Button
              label="Reset"
              onClick={handleDetailClearFilter}
              className="p-button-sm p-button-secondary"
            />
          </div>
          <div className="scroll-container">
            <DataTable value={incomingReport} paginator rows={10} tableStyle={{ minWidth: "50rem" }}>
              <Column field="user_id" header="User Id" />
              <Column field="caller_number" header="Caller Number" />
              <Column field="callee_number" header="Callee Number" />
              <Column field="start_time" header="Start Time" body={(rowData) => formatDateTime(rowData.start_time)} />
              <Column field="end_time" header="End Time" body={(rowData) => formatDateTime(rowData.end_time)} />
              <Column header="Trace ID" body={(rowData) => rowData.trace_id || "-"} />
              <Column header="Action" body={actionBodyTemplate} />
            </DataTable>
          </div>
        </div>
      </div>
      {/* <ToastNotification
            show_toast={showToast}
            set_show_toast={setShowToast}
            {...toastProps}
          />
          <Modal show={showToastModal} centered onHide={() => setShowToastModal(false)} size="sm">
            <Modal.Body className="text-center">
              <h5>{toastMessage}</h5>
              <LottieAnimation animationData={"https://assets6.lottiefiles.com/packages/lf20_touohxv0.json"} />
            </Modal.Body>
          </Modal> */}



      {showSidePanel && (
        <div
          
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            backdropFilter: 'blur(2px)',
            zIndex: 1045,
          }}
          onClick={() => setShowSidePanel(false)}
        />
      )}


      <div
        className="custom-scrollbar-panel"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: showSidePanel ? 'translate(-50%, -50%)' : 'translate(-50%, -150%)',
          transition: 'transform 0.3s ease-in-out',
          zIndex: 1050,
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
          width: '70%',
          maxHeight: '70%',
          overflowY: 'auto',
          padding: '20px',
          display: showSidePanel ? 'block' : 'none',
        }}
      >

        {showSidePanel && (mainCall || relatedCalls.length > 0) && (
          <>
            {/* FIXED CALL INFO SECTION */}

            <div  >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h5>Call Information</h5>
                <button
                  onClick={() => setShowSidePanel(false)}
                  style={{
                    border: 'none',
                    background: '#dc3545',
                    color: '#fff',
                    borderRadius: '4px',
                    padding: '4px 8px',
                  }}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>

              {mainCall && (
                <div style={{ marginBottom: '20px', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
                  <h3>{mainCall.callee_number}</h3>
                  <div style={{ display: 'flex', gap: '60px', marginTop: '20px' }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <p>Call Sid:</p>
                      <p>Trace ID:</p>
                      <p>Start Date:</p>
                      <p>End Date:</p>
                      <p>Caller Number:</p>
                      {/* <p>Agent Name:</p>
              <p>Agent Number:</p> */}
                      {/* <p>Call Group Name:</p> */}
                      <p>Answer Status:</p>
                      <p>Recording:</p>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <p>{mainCall.call_sid}</p>
                      <p>{mainCall.trace_id}</p>
                      <p>{formatDateTime(mainCall.start_time)}</p>
                      <p>{formatDateTime(mainCall.end_time)}</p>
                      <p>{mainCall.caller_number}</p>
                      {/* <p>{mainCall.agent_name}</p>
              <p>{mainCall.agent_number}</p> */}
                      {/* <p>{mainCall.queue_name}</p> */}
                      {/* <p>{mainCall.queue_name}</p> */}
                      <p>
                        {" "}
                        {mainCall.answer_status === "1" ? (
                          <p style={statusStyles.success}>
                            Success
                          </p>
                        ) : (
                          <p style={statusStyles.failed}>
                            Failed
                          </p>
                        )}
                      </p>
                      {mainCall.recording_file && (
                        <audio controls style={{ width: '100%', height: '30px' }}>
                          <source src={`https://your-cdn-path/${mainCall.recording_file}`} type="audio/wav" />
                          Your browser does not support the audio element.
                        </audio>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>



            <div >
              <div style={{ display: "flex", gap: "50px", padding: "10px" }}>
                <h5 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <PhoneIncoming size={18} color="green" strokeWidth={2.5} />
                  Incoming Call
                </h5>
                <h5 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <PhoneOutgoing size={18} color="blue" strokeWidth={2.5} />
                  Outbound Call
                </h5>
              </div>

              {showSidePanel && (
                <div style={{ marginTop: '20px', overflow: "auto", }} className="my-data-table" >
                  <DataTable
                    value={[mainCall, ...relatedCalls.filter(c => c.trace_id === mainCall.trace_id)]}
                    tableStyle={{ minWidth: "100rem" }}
                  >
                    <Column
                      header=""
                      body={(rowData) =>
                        rowData.call_sid === mainCall.call_sid ? (
                          <PhoneIncoming size={18} color="green" strokeWidth={2.5} />
                        ) : (
                          <PhoneOutgoing size={18} color="blue" strokeWidth={2.5} />
                        )
                      }
                      style={{ width: '3rem' }}
                    />
                    <Column field="call_sid" header="Call SID" />
                    <Column field="caller_number" header="Caller Number" />
                    <Column field="callee_number" header="Callee Number" />
                    <Column
                      header="Answer Status"
                      body={(row) => (
                        <p style={row.answer_status === "1" ? statusStyles.success : statusStyles.failed}>
                          {row.answer_status === "1" ? "Success" : "Failed"}
                        </p>
                      )}
                    />
                    <Column field="start_time" header="Start Time" body={(row) => formatDateTime(row.start_time)} />
                    <Column field="end_time" header="End Time" body={(row) => formatDateTime(row.end_time)} />
                    <Column field="billing_duration" header="Billing Duration" />
                    <Column field="patch_duration" header="Patch Duration" />
                    <Column field="bridge_ring_duration" header="Ring Duration" />
                  </DataTable>
                </div>
              )}
            </div>


            {/* RELATED CALLS TABLE WRAPPER */}

            <div style={{ overflow: "auto" }} className="my-data-table" >
              {relatedCalls.length > 0 && (
                <>
                  <h5 style={{ marginTop: '30px', marginLeft: "10px" }}>Related Calls</h5>
                  <div
                    style={{
                      marginTop: '20px',
                      width: '100%',
                      paddingBottom: '10px',
                    }}
                  >
                    <DataTable value={relatedCalls} paginator rows={5} tableStyle={{ minWidth: '1500px' }}>
                      <Column field="call_sid" header="Call SID" />
                      <Column field="caller_number" header="Caller Number" />
                      <Column field="agent_name" header="Agent Name" />
                      <Column field="agent_number" header="Agent Number" />
                      <Column
                        field="start_time"
                        header="Start Time"
                        body={(row) => formatDateTime(row.start_time)}
                      />
                      <Column
                        field="end_time"
                        header="End Time"
                        body={(row) => formatDateTime(row.end_time)}
                      />
                      <Column
                        header="Answer Status"
                        body={(row) => (
                          <p style={row.answer_status === "1" ? statusStyles.success : statusStyles.failed}>
                            {row.answer_status === "1" ? "Success" : "Failed"}
                          </p>
                        )}
                      />
                      <Column field="patch_duration" header="Patch Duration (sec)" />
                      <Column field="billing_duration" header="Billing Duration (sec)" />
                      <Column field="total_hold_duration" header="Hold Duration (sec)" />
                      <Column
                        header="Recording"
                        body={(row) =>
                          row.recording_file ? (
                            <audio controls style={{ height: '30px' }}>
                              <source src={`https://your-cdn-path/${row.recording_file}`} type="audio/wav" />
                            </audio>
                          ) : "-"
                        }
                      />
                    </DataTable>


                  </div>
                </>
              )}
            </div>

          </>
        )}



      </div>




    </div>
  );
};

export default DidDetailPage;
